import { URL, handleErrors } from "./depannageActions"
import { getParams } from "../../utilities/Addons"
import { catchApiError } from "./apiHelpers"

export const FETCH_ADRESSES_BEGIN = "FETCH_ADRESSES_BEGIN"
export const FETCH_ADRESSES_SUCCESS = "FETCH_ADRESSES_SUCCESS"
export const FETCH_ADRESSES_ERROR = "FETCH_ADRESSES_ERROR"
export const FETCH_ADRESSES_RESET = "FETCH_ADRESSES_RESET"

export const fetchAdressesBegin = () => ({
	type: FETCH_ADRESSES_BEGIN,
})

export const fetchAdressesSucces = (addresses) => ({
	type: FETCH_ADRESSES_SUCCESS,
	payload: addresses,
})

export const fetchAdressesError = (error) => ({
	type: FETCH_ADRESSES_ERROR,
	payload: { error },
})

export const fetchAdressesReset = () => ({
	type: FETCH_ADRESSES_RESET,
})

export function fetchAdresses() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAdressesBegin())
		let url = `${URL}api/adresses`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAdressesSucces(json))
			})
			.catch(catchApiError(dispatch, fetchAdressesError))
	}
}

export const FETCH_ADRESSESV2_BEGIN = "FETCH_ADRESSESV2_BEGIN"
export const FETCH_ADRESSESV2_SUCCESS = "FETCH_ADRESSESV2_SUCCESS"
export const FETCH_ADRESSESV2_ERROR = "FETCH_ADRESSESV2_ERROR"
export const FETCH_ADRESSESV2_RESET = "FETCH_ADRESSESV2_RESET"

export const fetchAdressesV2Begin = () => ({
	type: FETCH_ADRESSESV2_BEGIN,
})

export const fetchAdressesV2Succes = (payload) => ({
	type: FETCH_ADRESSESV2_SUCCESS,
	payload,
})

export const fetchAdressesV2Error = (error) => ({
	type: FETCH_ADRESSESV2_ERROR,
	payload: { error },
})

export const fetchAdressesV2Reset = () => ({
	type: FETCH_ADRESSESV2_RESET,
})

export function fetchAdressesV2(params) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAdressesV2Begin())
		let url = `${URL}api/adressesv2${getParams(params)}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAdressesV2Succes(json))
			})
			.catch(catchApiError(dispatch, fetchAdressesV2Error))
	}
}

export const FETCH_LOCALITES_BEGIN = "FETCH_LOCALITES_BEGIN"
export const FETCH_LOCALITES_SUCCESS = "FETCH_LOCALITES_SUCCESS"
export const FETCH_LOCALITES_ERROR = "FETCH_LOCALITES_ERROR"
export const FETCH_LOCALITES_RESET = "FETCH_LOCALITES_RESET"

export const fetchLocalitesBegin = () => ({
	type: FETCH_LOCALITES_BEGIN,
})

export const fetchLocalitesSucces = (payload) => ({
	type: FETCH_LOCALITES_SUCCESS,
	payload,
})

export const fetchLocalitesError = (error) => ({
	type: FETCH_LOCALITES_ERROR,
	payload: { error },
})

export const fetchLocalitesReset = () => ({
	type: FETCH_LOCALITES_RESET,
})

export function fetchLocalites(params) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLocalitesBegin())
		let url = `${URL}api/localites${getParams(params)}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLocalitesSucces(json))
				// Résolu aussi par la promesse : « Utiliser cette adresse » a
				// besoin des localités de CE NPA (le store ne garde que la
				// dernière recherche, tous champs confondus).
				return json
			})
			.catch(catchApiError(dispatch, fetchLocalitesError))
	}
}
